//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscEyeFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11.9998 19.91C17.1298 19.91 21.2998 16.37 23.4098 11.91C21.3198 7.47 17.1598 3.91 11.9998 3.91C6.86984 3.91 2.69984 7.45 0.589844 11.91C2.68984 16.35 6.83984 19.91 11.9998 19.91ZM11.9998 7.5C14.4798 7.5 16.4998 9.52 16.4998 12C16.4998 14.48 14.4798 16.5 11.9998 16.5C9.51984 16.5 7.49984 14.48 7.49984 12C7.49984 9.52 9.51984 7.5 11.9998 7.5Z" fill="currentColor" /></svg>;
}
export default IconMiscEyeFill;